import { render, staticRenderFns } from "./journaltable.vue?vue&type=template&id=bd59ed78&scoped=true&"
import script from "./journaltable.vue?vue&type=script&lang=js&"
export * from "./journaltable.vue?vue&type=script&lang=js&"
import style0 from "./journaltable.vue?vue&type=style&index=0&id=bd59ed78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd59ed78",
  null
  
)

export default component.exports